import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'
import { IMembershipPeriod, IMembershipPlan } from '@/data/models/MembershipPlan'

export class MembershipPlanApiService extends ApiService {
  /**
   * Returns paginated list of Membership plans
   */
  static async getAll(): Promise<IServiceResponse<IMembershipPlan>> {
    return this.axios.get('membership-plans')
      .then((response: AxiosResponse<IServiceResponse<IMembershipPlan>>) => response.data)
  }

  static async getPeriods(): Promise<IServiceResponse<IMembershipPeriod>> {
    return this.axios.get('membership-periods')
      .then((response: AxiosResponse<IServiceResponse<IMembershipPeriod>>) => response.data)
  }

  /**
   * Given data, creates new entry in database
   *
   * @param data
   */
  static async create(data: IMembershipPlan): Promise<IServiceResponse<IMembershipPlan>> {
    return this.axios.post('membership-plans', data)
      .then((response: AxiosResponse<IServiceResponse<IMembershipPlan>>) => response.data)
  }

  /**
   * Given data, updates membership plan's entry in database
   *
   * @param data
   */
  static async update(data: IMembershipPlan): Promise<IServiceResponse<IMembershipPlan>> {
    return this.axios.put(`membership-plans/${data.id}`, data)
      .then((response: AxiosResponse<IServiceResponse<IMembershipPlan>>) => response.data)
  }

  /**
   * Given membership plan's id, deletes event in database
   *
   * @param membershipPlanId
   */
  static async delete(membershipPlanId: string): Promise<AxiosResponse> {
    return this.axios.delete(`membership-plans/${membershipPlanId}`)
  }

  static async updatePaymentStatus(membershipPaymentId: number, data: object): Promise<IServiceResponse<any>> {
    return this.axios.post(`membership-payments/${membershipPaymentId}/status`, data)
      .then((response: AxiosResponse<IServiceResponse<any>>) => response.data)
  }
}
